import { styled } from '@mui/material/styles'

const drawerWidth = 385
const getStyles = (theme) => (
  {
    viewer: {
      '& .adsk-viewing-viewer': {
        height: 'calc(100% - 118px) !important'
      }
    },
    root: {
      display: 'flex'
    },
    appBar: {
      transition: theme.transitions?.create(['margin', 'width'], {
        easing: theme.transitions?.easing.sharp,
        duration: theme.transitions?.duration.leavingScreen
      })
    },
    contentList: {
      maxHeight: '70vh',
      marginBottom: '5vh',
      overflow: 'auto'
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions?.create(['margin', 'width'], {
        easing: theme.transitions?.easing.easeOut,
        duration: theme.transitions?.duration.enteringScreen
      })
    },
    menuButton: {
      marginRight: theme.spacing && theme.spacing(2)
    },
    hide: {
      display: 'none'
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0
    },
    drawerPaper: {
      width: drawerWidth,
      [theme.breakpoints?.down('sm')]: {
        width: 200
      }
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing && theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins?.toolbar,
      justifyContent: 'flex-end'
    },
    content: {
      flexGrow: 1,
      // padding: theme.spacing(3),
      transition: theme.transitions?.create('margin', {
        easing: theme.transitions?.easing.sharp,
        duration: theme.transitions?.duration.leavingScreen
      }),
      marginLeft: -drawerWidth
    },
    contentShift: {
      transition: theme.transitions?.create('margin', {
        easing: theme.transitions?.easing.easeOut,
        duration: theme.transitions?.duration.enteringScreen
      }),
      marginLeft: 0,
      overflowX: 'hidden'
    }
  }
)
const PREFIX = 'ViewerStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const ViewerStyle = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  ViewerStyle
}
